// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ooDtw","layer":"styles_layer__em8oJ"};